<template>
  <div id="rating-form" class="pb-3" v-if="question && question.is_enabled">
    <div v-if="content">
      <div class="question-title mb-2">
        {{ question.question }}
        <sup class="text-danger font-weight-bold" v-if="content.required">
          *
        </sup>
      </div>
      <div>
          <ImageRender
            v-if="question.image"
            :imgBase64="question.image" :showCloseButton="false"/>
      </div>
      <div v-if="content.visible">
        <b-row>
          <b-col
            v-for="(option, key) in content.attributes.options"
            :key="key"
            @click="selectedRating = option"
            class="text-center d-inline-block px-2"
          >
            <b-img
              v-if="!selectedRating || selectedRating.value < option.value"
              :src="
                require(`@/assets/images/${content.attributes.icon}-outline.svg`)
              "
              alt="Rating"
              fluid
            />
            <b-img
              v-else
              :src="require(`@/assets/images/${content.attributes.icon}.svg`)"
              alt="Rating"
              fluid
            />
          </b-col>
        </b-row>
        <b-row v-if="answers[question.question]" class="mt-3">
          <b-col class="text-center font-weight-bold">
            {{ answers[question.question].label || "" }}
          </b-col>
        </b-row>
        <b-form-invalid-feedback :state="isInvalid(question.question)">
          {{ errorMessage(question.question) }}
        </b-form-invalid-feedback>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageRender from "../../../components/ImageRender.vue";
export default {
  name: "Rating",
  components: {
    ImageRender,
  },
  props: ["question", "answers"],
  data() {
    return {
      selectedRating: {value: 0, label: ""},
      content: null,
    };
  },
  watch: {
    selectedRating() {
      if (this.selectedRating)
        this.answers[
          this.question.question
        ] = this.question.contents[0].attributes.options[
          (this.selectedRating).value - 1
        ];

    },
  },
  methods: {
    isInvalid(field) {
      if (this.errors === null) {
        return null;
      } else {
        return !Object.keys(this.errors).includes(field)
          ? null
          : !Object.keys(this.errors).includes(field);
      }
    },
    errorMessage(field) {
      if (this.errors === null) {
        return "";
      } else if (Object.keys(this.errors).includes(field)) {
        return Array.isArray(this.errors[field])
          ? this.errors[field].join(" ")
          : this.errors[field];
      }
    },
  },
  computed: {
    ...mapGetters("survey", ["errors"]),
  },
  created() {
    if (this.question.contents.length) this.content = this.question.contents[0];

    if (this.answers[this.question.question] !== undefined)
      this.selectedRating = this.answers[this.question.question];
    else this.answers[this.question.question] = "";
  },
};
</script>

<style>
</style>